import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as userAction from "../../actions/userActions";
import * as baseActions from "../../actions/baseActions";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
import Popup from "../Popup";
import ReadMoreParagraph from "../ReadMore";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";
import { getSubdomainPath } from "../../utils/helpers";

const Index = (props) => {
  const history = useNavigate();
  const { setting, actions, userInfo } = props;
  const [signupModalShow, setSignupModalShow] = useState(false);
  const [popUpLoader, setPopUpLoader] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await actions.getSettingData();

        if (result?.message) {
          console.log("message", result.message);
        }
      } catch (error) {
        console.error("Failed to fetch settings", error);
      }
    };
    fetchData();
  }, [actions]);

  const getSignupPopup = (name) => {
    if (setting.email_approval_required === 1) {
      setSignupModalShow(true);
      return;
    }

    history({
      pathname: "/register",
    });
  };

  const handleSubmitCheckEmail = async (data) => {
    setPopUpLoader(true);
    const result = await actions.sendEmailForVerification(data);
    setPopUpLoader(false);
    if (result?.status === 200) {
      setSignupModalShow(false);
      setPopupMessage(result?.message || "Verification email sent successfully!");
      setShowPopup(true);
    } else {
      setPopUpLoader(false);
      setPopupMessage(result?.message || "Failed to send verification email.");
      setShowPopup(true);
    }
  };

  const subDomainPath = getSubdomainPath();

  return (
    <>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="footerleft text-md-start ">
                <Link className="logo m-0" to="/" title="Home" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                  <img
                    src={setting?.logo_path}
                    alt={setting?.name}
                    className=""
                    style={(subDomainPath === "essecuat" || subDomainPath === "essec" || subDomainPath === "uat")
                      ? { maxWidth: "200px", maxHeight: "59px" } : {}
                    }
                  />
                </Link>
                {setting?.about_menu_label_enable === "1" && <ReadMoreParagraph text={setting?.about_me || ''} maxLength={170} />}
              </div>
            </div>
            <div className="col-md-4 offset-md-1 pt-4 pt-md-0">
              <div className="footertop quick_box">
                <h3>Quick Links</h3>
                <ul className="quicklinks">
                  <li>
                    <Link className="logo" to="/" title="Home" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link className="logo" to="/page/privacy-policy" title="Privacy Policy">
                      Privacy Policy
                    </Link>
                  </li>
                  {setting?.about_us_enable === "1" && (<li>
                    <Link className="logo" to="/about-us" title="About">
                      {setting?.menu_html}
                    </Link>
                  </li>)}
                  <li>
                    <Link
                      className="logo"
                      to="/page/terms-and-conditions"
                      title="Terms and conditions"
                    >
                      Terms and Conditions
                    </Link>
                  </li>
                  {setting?.is_sso_enable !== "1" && !userInfo?.id &&
                    <li>
                      <Link className="logo" to="/login" title="Login">
                        Login
                      </Link>
                    </li>
                  }
                  <li>
                    <Link className="logo" to="/faq" title="FAQ">
                      FAQ
                    </Link>
                  </li>
                  {setting?.is_sso_enable !== "1" && !userInfo?.id &&
                    <li>
                      <Link className="logo" onClick={getSignupPopup} to={'#'} title="Sign Up">
                        Sign Up
                      </Link>
                    </li>
                  }
                  <li>
                    <Link className="logo" to="/contact-us" title="Contact Us">
                      Contact Us
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-3 pt-4 pt-md-0">
              <div className="footertop ml-md-auto">
                {
                  setting.facebook_link || setting.twitter_link || setting.linkedin_link || setting.youtube_link || setting.instagram_link || setting.spotify_link ? <h3>Connect With Us</h3> : ''
                }

                <ul className="sociallink">
                  <li className={setting.facebook_link ? '' : 'd-none'}>
                    <a
                      className="App-link"
                      href={setting.facebook_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" title='Facebook'></i>
                    </a>
                  </li>
                  <li className={setting.twitter_link ? '' : 'd-none'}>
                    <a
                      className="App-link"
                      href={setting.twitter_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img className="withouthoverShow" src="/assets/images/twiter_x.svg" width={23} height={23} title='Twitter' alt="" />
                      <img className="withhoverShow" src="/assets/images/twiter_xhover.svg" width={23} height={23} title='Twitter' alt="" />
                    </a>
                  </li>
                  <li className={setting.linkedin_link ? '' : 'd-none'}>
                    <a
                      className="App-link"
                      href={setting.linkedin_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-linkedin" title='Linkedin'></i>
                    </a>
                  </li>

                  <li className={setting.youtube_link ? '' : 'd-none'}>
                    <a
                      className="App-link"
                      href={setting.youtube_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" title='Youtube'></i>
                    </a>
                  </li>
                  <li className={setting.instagram_link ? '' : 'd-none'}>
                    <a
                      className="App-link"
                      href={setting.instagram_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" title='Instagram'></i>
                    </a>
                  </li>
                  <li className={setting.spotify_link ? '' : 'd-none'}>
                    <a
                      className="App-link"
                      href={setting.spotify_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-spotify" title='Spotify'></i>
                    </a>
                  </li>
                </ul>
              </div>
              {setting.support_email &&
                <div className="footertop ml-md-auto" style={{ margin: `9px` }}>
                  <p> <i className="far fa-envelope"></i> &nbsp;
                    <a className="App-link" href={"mailto:" + setting.support_email}>
                      {setting.support_email}
                    </a>
                  </p>
                </div>
              }
            </div>
          </div>
        </div>
        <div className="copyright">
          {setting.copy_right && <div className="container">
            <p> {setting.copy_right}</p>
          </div>}
          <div className="container mt-1">
            <p>Powered by <a href='https://www.vlookup.ai/partnerships' target="_blank" rel="noopener noreferrer">vLookUp.ai</a></p>
          </div>
        </div>
      </footer>

      {signupModalShow && (
        <Popup
          userInfo={userInfo}
          show={signupModalShow}
          handleSubmitCheckEmail={handleSubmitCheckEmail}
          onHide={() => setSignupModalShow(false)}
          setPopUpLoader={setPopUpLoader}
          popUpLoader={popUpLoader}
          setting={setting || {}}
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => setShowPopup(false)}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />
    </>
  );
};

Index.propTypes = {
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),

  actions: PropTypes.shape({
    getSettingData: PropTypes.func.isRequired,
    sendEmailForVerification: PropTypes.func.isRequired,
  }).isRequired,

  setting: PropTypes.shape({
    email_approval_required: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    logo_path: PropTypes.string,
    name: PropTypes.string,
    about_me: PropTypes.string,
    menu_html: PropTypes.string,
    copy_right: PropTypes.string,
    support_email: PropTypes.string,
    facebook_link: PropTypes.string,
    twitter_link: PropTypes.string,
    linkedin_link: PropTypes.string,
    youtube_link: PropTypes.string,
    instagram_link: PropTypes.string,
    spotify_link: PropTypes.string,
    module_data: PropTypes.string,
    about_menu_label_enable: PropTypes.string,
    about_us_enable: PropTypes.string,
    is_sso_enable: PropTypes.string
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    userInfo: state.userInfo,
    isAuth: state.isAuth,
    setting: state.setting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...userAction, ...baseActions, ...settingActions, ...homePageActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
